var _rect, _defs, _defs2, _defs3, _defs4, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobSceneHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#001220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#a86fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#a86fff",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#a86fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#a86fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#a86fff",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#a86fff",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 486.7C-53.7 446.2 -107.3 405.6 -155.8 376C-204.2 346.4 -247.3 327.7 -300.5 300.5C-353.7 273.4 -417 237.8 -449.7 186.3C-482.4 134.8 -484.6 67.4 -486.7 0L0 0Z",
    fill: "#1b4992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 243.4C-26.8 223.1 -53.7 202.8 -77.9 188C-102.1 173.2 -123.7 163.8 -150.3 150.3C-176.9 136.7 -208.5 118.9 -224.8 93.1C-241.2 67.4 -242.3 33.7 -243.4 0L0 0Z",
    fill: "#a86fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -486.7C63.9 -466.6 127.8 -446.4 169.1 -408.4C210.5 -370.4 229.5 -314.5 279.3 -279.3C329.2 -244.1 410 -229.4 449.7 -186.3C489.4 -143.1 488.1 -71.6 486.7 0L0 0Z",
    fill: "#1b4992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -243.4C31.9 -233.3 63.9 -223.2 84.6 -204.2C105.3 -185.2 114.7 -157.3 139.7 -139.7C164.6 -122 205 -114.7 224.8 -93.1C244.7 -71.6 244 -35.8 243.4 0L0 0Z",
    fill: "#a86fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobSceneHaikei);
export default __webpack_public_path__ + "static/media/blob-scene-haikei.dc2341f4b159194468153ade7acdf9ef.svg";
export { ForwardRef as ReactComponent };